var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.resource.data)?_c('div',[(_vm.resource.type == 'project')?void 0:_vm._e()],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }